export default __webpack_public_path__ + "static/media/brookshire-logo.cd5debeb.png";